import { createFileRoute } from '@tanstack/react-router'
import { PropertiesPage } from '../../../components/PropertiesPage'

// Define the search params schema
interface PropertiesSearch {
  q?: string
  entity_type?: 'asset' | 'document' | 'user'
  data_type?: string
  category?: string
}

export const Route = createFileRoute('/$org/properties/')({
  component: Properties,
  validateSearch: (search: Record<string, unknown>): PropertiesSearch => {
    return {
      q: search.q ? String(search.q) : undefined,
      entity_type: search.entity_type as 'asset' | 'document' | 'user' | undefined,
      data_type: search.data_type ? String(search.data_type) : undefined,
      category: search.category ? String(search.category) : undefined,
    }
  },
})

function Properties() {
  return <PropertiesPage />
}